import { Stash } from './Stash'
import equal from 'fast-deep-equal/es6'

export class SimpleStash<T = any> extends Stash<T> {
  protected isChangedImpl(equalityCallback?: (a, b) => boolean): boolean {
    if (equalityCallback) {
      return !equalityCallback(this.current, this.previous)
    } else {
      return !equal(this.current, this.previous)
    }
  }
}
